import { render, staticRenderFns } from "./FileManageDialog.vue?vue&type=template&id=5cfa12a4&"
import script from "./FileManageDialog.vue?vue&type=script&lang=js&"
export * from "./FileManageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cfa12a4')) {
      api.createRecord('5cfa12a4', component.options)
    } else {
      api.reload('5cfa12a4', component.options)
    }
    module.hot.accept("./FileManageDialog.vue?vue&type=template&id=5cfa12a4&", function () {
      api.rerender('5cfa12a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ApprovalMatters/ApprovalChecklist/components/FileManageDialog.vue"
export default component.exports